import { render, staticRenderFns } from "./WelcomeMessageEditor.vue?vue&type=template&id=56e1b0f4&"
import script from "./WelcomeMessageEditor.vue?vue&type=script&lang=ts&"
export * from "./WelcomeMessageEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports